import PropTypes from "prop-types";
import { useEffect } from "react";
import Card from "../../components/Cards/Card";
import ComboHeader from "../../components/ComboHeader/ComboHeader";
import CardWrapper from "../../components/LayoutCardsWrapper/CardWrapper";
import LayoutCardsWrapper from "../../components/LayoutCardsWrapper/LayoutCardsWrapper";
import NativeObject from "../../components/NativeObject/NativeObject";
import { useQlik } from "../../context/Qlik";

function DashboardDesktop({ app, config }) {
  const { container } = config.dashboard;
  const { setSwitchOnDemand } = useQlik();

  useEffect(() => {
    setSwitchOnDemand(false);
  }, [setSwitchOnDemand]);

  return (
    <div className="app dashboard">
      <div className="appContent">
        <LayoutCardsWrapper>
          {/* Mapa de Envio */}
          <div style={{ width: "100%", paddingInline: "10px" }}>
            <ComboHeader
              reference={{ title: { hard: container[0].name } }}
            ></ComboHeader>
          </div>

          <CardWrapper customStyle={{ height: "50%" }}>
            <Card
              expandable
              exportTable
              app={app}
              exportContainer
              exportTableId={container[0].cards[0].nativeObject.id}
              header={{
                tooltip: container[0].cards[0].title.tooltip,
                hardTitle: container[0].cards[0].title.hardTitle,
              }}
              style={{ width: "100%", height: "100%" }}
            >
              <NativeObject
                app={app}
                key={container[0].cards[0].nativeObject.valueId}
                reference={{
                  id: container[0].cards[0].nativeObject.id,
                }}
              />
            </Card>
          </CardWrapper>

          {/* Análise Reprocessamento */}
          <div style={{ width: "100%", paddingInline: "10px" }}>
            <ComboHeader
              reference={{ title: { hard: container[1].name } }}
            ></ComboHeader>
          </div>

          <CardWrapper customStyle={{ height: "50%" }}>
            <Card
              expandable
              exportTable
              app={app}
              exportContainer
              exportTableId={container[1].cards[0].nativeObject.id}
              header={{
                hardTitle: container[1].cards[0].title.hardTitle,
              }}
              style={{ width: "100%", height: "100%" }}
            >
              <NativeObject
                app={app}
                key={container[1].cards[0].nativeObject.valueId}
                reference={{
                  id: container[1].cards[0].nativeObject.id,
                }}
              />
            </Card>
          </CardWrapper>
        </LayoutCardsWrapper>
      </div>
    </div>
  );
}

DashboardDesktop.defaultProps = {
  app: null,
  config: {},
};

DashboardDesktop.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default DashboardDesktop;
